import { PROPERTY_IMAGE_ANALYSIS_API } from '@aloft/toolkit-shared';

import { fetchGetPropertyImageAnalysis } from '../../../../../hooks/api/toolkitComponents.ts';
import { useToolkitContext } from '../../../../../hooks/api/toolkitContext.ts';

export const useAnalyzeSubjectImages = () => {
  const { fetcherOptions } = useToolkitContext();

  return async (orderID: string) => {
    try {
      const response = await fetchGetPropertyImageAnalysis({
        ...fetcherOptions,
        pathParams: {
          orderID,
          propertyID: 'subject',
        },
      });
      return PROPERTY_IMAGE_ANALYSIS_API.GET.RESPONSE.parse(response).content;
    } catch (e: unknown) {
      console.error('Failed to get subject image analysis', e);
      return undefined;
    }
  };
};
